import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ControlContainer, NgForm, NgModel } from '@angular/forms';
import {
  ICustomerDetails,
  emptyAddress,
  IAddressSuggestion,
  AddressSearch,
  AddressMode,
} from '@nx-ng/types';
import { FormErrorService } from '@nx-ng/services';

@Component({
  selector: 'nx-ng-billing-address',
  templateUrl: './billing-address.component.html',
  styleUrls: ['./billing-address.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class BillingAddressComponent implements OnInit {
  @Input()
  customerDetails: ICustomerDetails | undefined = {
    firstName: '',
    lastName: '',
    telephoneNumber: '',
    address: emptyAddress,
  };

  @Input()
  sameAsAccountHolder = false;

  @Input()
  addressSuggestions: IAddressSuggestion[] = [];

  @Input()
  childTicketVerifyInProgress = false;

  @Output()
  toggled: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  addressSearch: EventEmitter<AddressSearch> = new EventEmitter<AddressSearch>();

  @Output()
  addressFound: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  postCodeManualChange: EventEmitter<string> = new EventEmitter<string>();

  addressMode: AddressMode = 'auto';

  @Input()
  postCodeValid: boolean | undefined = undefined;

  constructor(private formErrorService: FormErrorService) {}

  get addressSearchContext(): string {
    return 'billing-address';
  }

  getFirstNameError(firstName: NgModel) {
    return this.formErrorService.getFirstNameError(firstName);
  }

  getLastNameError(lastName: NgModel) {
    return this.formErrorService.getLastNameError(lastName);
  }

  handleBillingChanged(sameAsAccountHolder: boolean) {
    this.toggled.emit(sameAsAccountHolder);
    this.addressMode = 'auto';
  }

  handleAddressSearch(event: AddressSearch) {
    this.addressSearch.emit(event);
  }

  handleAddressFound() {
    this.addressMode = 'manual';
    this.addressFound.emit();
  }

  handlePostCodeManualChange(value: string) {
    this.postCodeManualChange.emit(value);
  }

  ngOnInit() {
    this.addressMode = this.customerDetails?.address?.address1
      ? 'manual'
      : 'auto';
  }
}
